module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "dlgdrag",
      rawName: "v-dlgdrag"
    }],
    staticClass: "dig setting-dig",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "dig_title clearFix"
  }, [_vm._m(0), _vm._v(" "), _c('Icon', {
    staticClass: "fr",
    attrs: {
      "type": "close-round"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogClose($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.errmsg) ? _c('div', {
    staticClass: "dig-main clearFix",
    staticStyle: {
      "color": "#f00",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.errmsg))]) : _c('div', {
    staticClass: "dig-main clearFix",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "form-grounp clearFix"
  }, [_c('label', {
    staticClass: "fl control-label"
  }, [_vm._v("页面标题")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm fl"
  }, [_c('Input', {
    staticStyle: {
      "width": "235px"
    },
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.settings.navigationBarTitleText),
      callback: function($$v) {
        _vm.$set(_vm.settings, "navigationBarTitleText", $$v)
      },
      expression: "settings.navigationBarTitleText"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-grounp clearFix"
  }, [_c('label', {
    staticClass: "fl control-label"
  }, [_vm._v("标题栏颜色")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm fl"
  }, [_c('Input', {
    staticStyle: {
      "width": "235px"
    },
    attrs: {
      "value": _vm.settings.navigationBarBackgroundColor,
      "disabled": true,
      "size": "large"
    }
  }), _vm._v(" "), _c('ColorPicker2', {
    attrs: {
      "format": "single",
      "size": "large"
    },
    model: {
      value: (_vm.settings.navigationBarBackgroundColor),
      callback: function($$v) {
        _vm.$set(_vm.settings, "navigationBarBackgroundColor", $$v)
      },
      expression: "settings.navigationBarBackgroundColor"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-grounp clearFix"
  }, [_c('label', {
    staticClass: "fl control-label"
  }, [_vm._v("文字颜色")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm fl"
  }, [_c('RadioGroup', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "size": "large",
      "type": "button"
    },
    model: {
      value: (_vm.settings.navigationBarTextStyle),
      callback: function($$v) {
        _vm.$set(_vm.settings, "navigationBarTextStyle", $$v)
      },
      expression: "settings.navigationBarTextStyle"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "white"
    }
  }, [_vm._v("白色")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "black"
    }
  }, [_vm._v("黑色")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dig-footer clearfix",
    staticStyle: {
      "position": "absolute",
      "left": "0",
      "right": "0px",
      "bottom": "0",
      "padding": "5px 40px 20px 40px"
    }
  }, [_c('div', {
    staticClass: "setting-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.settingsSave($event)
      }
    }
  }, [_vm._v("保存")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("设置")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7a56f9d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/setting.vue
// module id = 193
// module chunks = 2